/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import Select from "react-select";
import Card from "../../../../components/Cards/Card";
import { getRemittanceSettingsValue } from "../../../../store/actions/remittance.action";
import {
  action_settings,
  authSettingsMap,
  customerApprovalMap,
  duplicateLoginSettings,
  enablePickupMap,
  hide_view,
  logoutRedirectUrlMap,
  mobileAppMap,
  noneMemberMap,
  overdraftMap,
  payOutAuthMap,
  receiptSettingsMap,
  requiredFieldsAttachMap,
  tillAccMap,
  transactionFieldSettings,
  userAgeLimitMap,
  wallet_settings,
} from "../../../../utils/helpers/objectHelpers";
import { RemittanceService } from "../../../../utils/services/remittance.service";

function Body({ domainBrand, remittanceValues, countries }) {
  const dispatch = useDispatch();

  const dictionary = domainBrand.domainBrand["languageDictionary"];

  const transactions = transactionFieldSettings(dictionary).map((i) => {
    if (i.name === "securityQuestionMandatory") {
      i = { ...i, value: remittanceValues?.securityQuestionMandatory };
    }
    if (i.name === "nameValidation") {
      i = { ...i, value: remittanceValues?.nameValidation || false };
    }
    if (i.name === "idTypeAndIDNumber") {
      i = { ...i, value: remittanceValues?.idTypeAndIDNumber || false };
    }
    return { ...i };
  });

  const duplicates = duplicateLoginSettings(dictionary).map((i) => {
    if (i.name === "supportDuplicateLoginForCashierOnMobileApp") {
      i = {
        ...i,
        value: remittanceValues?.supportDuplicateLoginForCashierOnMobileApp,
      };
    }

    if (i.name === "showQuestionAnswerInPayinReceipt") {
      i = { ...i, value: remittanceValues?.showQuestionAnswerInPayinReceipt };
    }
    return { ...i };
  });

  const receipts = receiptSettingsMap(dictionary).map((i) => {
    if (i.name === "showQuestionAnswerInPayoutReceipt") {
      i = { ...i, value: remittanceValues?.showQuestionAnswerInPayoutReceipt };
    }
    if (i.name === "showQuestionAnswerInPayinReceipt") {
      i = { ...i, value: remittanceValues?.showQuestionAnswerInPayinReceipt };
    }
    return { ...i };
  });

  const auths = authSettingsMap(dictionary).map((i) => {
    if (i.name === "enableTwoFactorSms") {
      i = { ...i, value: remittanceValues?.enableTwoFactorSms };
    }
    return { ...i };
  });

  const payOuts = payOutAuthMap(dictionary).map((i) => {
    if (i.name === "enableTwoFactorSms") {
      i = { ...i, value: remittanceValues?.enableTwoFactorSms };
    }
    return { ...i };
  });

  const customers = customerApprovalMap(dictionary).map((i) => {
    return { ...i };
  });

  const userAge = userAgeLimitMap(dictionary).map((i) => {
    if (i.name === "sendMoneyAgeLimitYears") {
      i = { ...i, value: remittanceValues?.sendMoneyAgeLimitYears };
    }
    if (i.name === "receiveMoneyAgeLimitYears") {
      i = { ...i, value: remittanceValues?.receiveMoneyAgeLimitYears };
    }
    return { ...i };
  });

  const requiredFieldsMap = requiredFieldsAttachMap(dictionary).map((i) => {
    return { ...i };
  });

  const logoutRedirect = logoutRedirectUrlMap(dictionary).map((i) => {
    if (i.name === "logoRedirectUrl") {
      i = { ...i, value: remittanceValues?.logoRedirectUrl };
    }
    return { ...i };
  });

  const mobileApps = mobileAppMap(dictionary).map((i) => {
    if (i.name === "androidVersion") {
      i = { ...i, value: remittanceValues?.androidVersion };
    }
    if (i.name === "iosVersion") {
      i = { ...i, value: remittanceValues?.iosVersion };
    }
    return { ...i };
  });

  const enablePick = enablePickupMap(dictionary).map((i) => {
    if (i.name === "enablePickupLocation") {
      i = { ...i, value: remittanceValues?.enablePickupLocation };
    }
    return { ...i };
  });

  const tillAcc = tillAccMap(dictionary).map((i) => {
    if (i.name === "enableTellersTillAccountPull") {
      i = { ...i, value: remittanceValues?.enableTellersTillAccountPull };
    }
    return { ...i };
  });

  const overdrafts = overdraftMap(dictionary).map((i) => {
    if (i.name === "overdraft") {
      i = { ...i, value: remittanceValues?.overdraft };
    }
    return { ...i };
  });

  const noneMembers = noneMemberMap(dictionary).map((i) => {
    if (i.name === "allowNoneMemberToBookBillPayment") {
      i = { ...i, value: remittanceValues?.allowNoneMemberToBookBillPayment };
    }
    if (i.name === "allowNoneMemberToBookAirtimePayment") {
      i = {
        ...i,
        value: remittanceValues?.allowNoneMemberToBookAirtimePayment,
      };
    }
    return { ...i };
  });

  const [open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hideView, setHideView] = useState(false);
  const [walletSettings, setWalletSettings] = useState(false);
  const [action, setAction] = useState(false);

  const [hideObject, setHideObject] = useState([...transactions]);
  const [walletObject, setWalletObject] = useState([...duplicates]);
  const [actionObject, setActionObject] = useState([...receipts]);
  const [authObject, setAuthObject] = useState([...auths]);
  const [payOutObject, setPayoutObject] = useState([...payOuts]);
  const [customerObject, setCustomerObject] = useState([...customers]);
  const [userAgeObject, setUserAgeObject] = useState([...userAge]);
  const [requiredFieldsObject, setRequiredFieldsObject] = useState([
    ...requiredFieldsMap,
  ]);
  const [logoutObject, setLogoutObject] = useState([...logoutRedirect]);
  const [mobileAppObject, setMobileAppObject] = useState([...mobileApps]);
  const [enableObject, setEnableObject] = useState([...enablePick]);
  const [tillAccObject, setTillAccObject] = useState([...tillAcc]);
  const [overdraftObject, setOverdraftObject] = useState([...overdrafts]);
  const [noneMembersObject, setNoneMembersObject] = useState([...noneMembers]);

  const [receiptSettings, setRecieptSettings] = useState(false);
  const [authSettings, setAuthSettings] = useState(false);
  const [payOutAuth, setPayOutAuth] = useState(false);
  const [sessionTimeout, setSessionTimeout] = useState(false);
  const [termsAndConds, setTermsAndConds] = useState(false);
  const [paymentTermsAndConds, setPaymentTermsAndConds] = useState(false);
  const [kyc, setKyc] = useState(false);
  const [ageLimit, setAgeLimit] = useState(false);
  const [requiredFields, setRequiredFields] = useState(false);
  const [apiSetup, setApiSetup] = useState(false);
  const [refundSettings, setRefundSettings] = useState(false);
  const [logoutUrl, setLogoutUrl] = useState(false);
  const [mobileApp, setMobileApp] = useState(false);
  const [enablePickup, setEnablePickup] = useState(false);
  const [enableTeller, setEnableTeller] = useState(false);
  const [enableOverdraft, setEnableOverdraft] = useState(false);
  const [serviceAvailable, setServiceAvailable] = useState(false);

  const [sessionControl, setSessionControl] = useState("");
  const [receiptTermsAndConds, setReceiptTermsAndConds] = useState("");
  const [paymentTermsAndConditions, setPaymentTermsAndConditions] = useState(
    remittanceValues?.paymentTermsAndConditions
  );

  const onChangeInputValue = (e) => {
    const temp = hideObject.map((i) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setHideObject([...temp]);
  };

  const onChangeWalletInput = (e) => {
    const temp = walletObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setWalletObject([...temp]);
  };

  const onChangeActionInput = (e) => {
    const temp = actionObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setActionObject([...temp]);
  };

  const onChangeAuthSettings = (e) => {
    const temp = authObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setAuthObject([...temp]);
  };

  const onChangePayoutInput = (e) => {
    const temp = payOutObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setPayoutObject([...temp]);
  };

  const onChangeCustomerInput = (e) => {
    const temp = customerObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });
    setCustomerObject([...temp]);
  };

  const onChangeUserAgeInput = (e) => {
    const temp = userAgeObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: parseFloat(e?.target?.value) };
      }
      return i;
    });
    setUserAgeObject([...temp]);
  };

  const onChangeRequiredFieldsInput = (e) => {
    const temp = requiredFieldsObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: parseFloat(e?.target?.value) };
      }
      return i;
    });
    setRequiredFieldsObject([...temp]);
  };

  const onChangeLogoutInput = (e) => {
    const temp = logoutObject.map((i, idx) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.value };
      }
      return i;
    });
    setLogoutObject([...temp]);
  };

  const onChangeMobileInput = (e) => {
    const temp = mobileAppObject.map((i) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.value };
      }
      return i;
    });
    setMobileAppObject([...temp]);
  };

  const onChangeEnableInput = (e) => {
    const temp = enableObject.map((i) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });

    setEnableObject([...temp]);
  };

  const onChangeTillAccInput = (e) => {
    const temp = tillAccObject.map((i) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });

    setTillAccObject([...temp]);
  };

  const onChangeOverdraftInput = (e) => {
    const temp = overdraftObject.map((i) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });

    setOverdraftObject([...temp]);
  };

  const onChangeMembersInput = (e) => {
    const temp = noneMembersObject.map((i) => {
      if (i.name === e.target.name) {
        i = { ...i, value: e.target.checked };
      }
      return i;
    });

    setNoneMembersObject([...temp]);
  };

  const updateRemittanceValue = async (payload) => {
    setLoading(true);
    const updateDto = payload?.map((i) => {
      return { key: i.name, value: i.value };
    });
    const dto = { organisationPreferenceList: updateDto };
    try {
      const response = await RemittanceService.updateRemittancesFeeSettings(
        dto
      );
      if (response.data.status === "SUCCESS") {
        toast.success(response.data.message);
        dispatch(getRemittanceSettingsValue());
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["title_remittance_settings"]
                : "Remittance Settings"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <>
              <Card>
                <ul className="list-group">
                  {/* 1 --> DONE** */}
                  <li
                    className="list-group-item collapse-text text-uppercase fw-bold"
                    onClick={() => setHideView(!hideView)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                    style={{ cursor: "pointer", borderBottom: "0px solid" }}
                  >
                    {hideView ? (
                      <i className="fa fa-minus" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-plus" aria-hidden="true" />
                    )}{" "}
                    &nbsp;
                    {dictionary
                      ? dictionary["WO_TRANSACTION_FIELD_SE_-1879249318"]
                      : "TRANSACTION FIELD SETTINGS"}
                  </li>
                  <Collapse in={hideView}>
                    <div id="example-collapse-text" className="px-3">
                      <div className="form-row py-4">
                        <h6 className="fw-bold">
                          {dictionary
                            ? dictionary["l_transaction_settings_info"]
                            : `Select the transaction fields your organisation would
                          like to have as mandatory.`}
                        </h6>
                        {hideObject?.map((i, idx) => {
                          return (
                            <React.Fragment>
                              <div className="col-md-6 col-lg-6" key={idx}>
                                <div className="py-3">
                                  <input
                                    type={"checkbox"}
                                    name={i.name}
                                    id={i.name}
                                    className="pe-3 check-box"
                                    onChange={(e) => onChangeInputValue(e)}
                                    value={i.value}
                                    defaultChecked={i.value}
                                  />
                                  <span className="ps-2 align-top">
                                    {i.title}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <div className="form-row pb-3">
                        <div className="col-lg-6 col-md-6" />
                        <div className="col-lg-6 col-md-6 float-end mb-3">
                          <button
                            onClick={() => updateRemittanceValue(hideObject)}
                            className="login100-form-btn btn-primary fw-bold text-uppercase"
                          >
                            {loading ? (
                              <>
                                <i className="fa fa-spinner fa-spin" />
                              </>
                            ) : (
                              `${
                                dictionary
                                  ? dictionary["b_save_fields"]
                                  : "Save Transaction Settings"
                              }`
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </ul>
              </Card>
              <Card>
                {/* 2  --> DONE** */}
                <ul className="list-group">
                  <li
                    className="list-group-item collapse-text pt-4 fw-bold"
                    onClick={() => setWalletSettings(!walletSettings)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                    style={{ cursor: "pointer", borderBottom: "0px solid" }}
                  >
                    {walletSettings ? (
                      <i className="fa fa-minus" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-plus" aria-hidden="true" />
                    )}{" "}
                    &nbsp;
                    {dictionary
                      ? dictionary["WO_DUPLICATE_LOGIN_SETT_-286348623"]
                      : "DUPLICATE LOGIN SETTINGS FOR CASHIER ON MOBILE APP"}
                  </li>
                  <Collapse in={walletSettings}>
                    <div id="example-collapse-text" className="px-3">
                      <div className="form-row py-4">
                        <h6 className="fw-bold">
                          {dictionary
                            ? dictionary["WO_USE_THIS_OPTION_TO_E_488554255"]
                            : `Use this option to enable and disable duplicate login for cashier on mobile app`}
                        </h6>
                        {walletObject?.map((i, idx) => {
                          return (
                            <React.Fragment>
                              <div className="col-md-6 col-lg-6" key={idx}>
                                <div className="py-3">
                                  <input
                                    type={"checkbox"}
                                    name={i.name}
                                    id={i.name}
                                    className="pe-3 check-box"
                                    onChange={(e) => onChangeWalletInput(e)}
                                    checked={i.value}
                                  />
                                  <span className="ps-2 align-top">
                                    {i.title}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <div className="form-row pb-3">
                        <div className="col-lg-6 col-md-6" />
                        <div className="col-lg-6 col-md-6 float-end mb-3">
                          <button
                            onClick={() => updateRemittanceValue(walletObject)}
                            className="login100-form-btn btn-primary fw-bold text-uppercase"
                          >
                            {loading ? (
                              <>
                                <i className="fa fa-spinner fa-spin" />
                              </>
                            ) : (
                              `${
                                dictionary ? dictionary["b_update"] : "UPDATE"
                              }`
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </ul>
              </Card>
              <Card>
                {/* 3 TBC */}
                <ul className="list-group">
                  <li
                    className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                    onClick={() => setAction(!action)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                    style={{ cursor: "pointer", borderBottom: "0px solid" }}
                  >
                    {action ? (
                      <i className="fa fa-minus" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-plus" aria-hidden="true" />
                    )}{" "}
                    &nbsp;
                    {dictionary
                      ? dictionary["para_payment_types"]
                      : "Enable Online Payment Methods"}
                  </li>
                  <Collapse in={action}>
                    <div id="example-collapse-text" className="px-3">
                      <div className="form-row py-4">
                        {action_settings.map((i, idx) => {
                          return (
                            <React.Fragment>
                              <div
                                className="col-md-6 col-lg-6"
                                key={i.id + idx}
                              >
                                <div className="py-3">
                                  <input
                                    type={"checkbox"}
                                    name={i.name}
                                    id={i.name}
                                    className="pe-3"
                                    style={{ width: "18px", height: "18px" }}
                                    onChange={(e) => onChangeActionInput(e)}
                                  />
                                  <span className="ps-2 align-top">
                                    {i.title}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <div className="form-row pb-3">
                        <div className="col-lg-6 col-md-6" />
                        <div className="col-lg-6 col-md-6 float-end mb-3">
                          <button
                            onClick={() => updateRemittanceValue(actionObject)}
                            className="login100-form-btn btn-primary fw-bold text-uppercase"
                          >
                            {loading ? (
                              <>
                                <i className="fa fa-spinner fa-spin" />
                              </>
                            ) : (
                              `${
                                dictionary ? dictionary["b_update"] : "UPDATE"
                              }`
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </ul>
              </Card>
              <Card>
                {/* 4 --> DONE**  */}
                <ul className="list-group">
                  <li
                    className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                    onClick={() => setRecieptSettings(!receiptSettings)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                    style={{ cursor: "pointer", borderBottom: "0px solid" }}
                  >
                    {action ? (
                      <i className="fa fa-minus" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-plus" aria-hidden="true" />
                    )}{" "}
                    &nbsp;
                    {dictionary
                      ? dictionary["para_receipts_settings"]
                      : "Receipt Settings"}
                  </li>
                  <Collapse in={receiptSettings}>
                    <div id="example-collapse-text" className="px-3">
                      <h6 className="fw-bold">
                        {dictionary
                          ? dictionary[
                              "para_select_which_extra_information_you_want_in_receipts"
                            ]
                          : `Select which extra information you want in the receipts.`}
                      </h6>
                      <div className="form-row py-4">
                        {actionObject.map((i, idx) => {
                          return (
                            <React.Fragment>
                              <div className="col-md-6 col-lg-6" key={idx}>
                                <div className="py-3">
                                  <input
                                    type={"checkbox"}
                                    name={i.name}
                                    id={i.name}
                                    className="pe-3 check-box"
                                    onChange={(e) => onChangeActionInput(e)}
                                    defaultChecked={i.value}
                                  />
                                  <span className="ps-2 align-top">
                                    {i.title}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <div className="form-row pb-3">
                        <div className="col-lg-6 col-md-6" />
                        <div className="col-lg-6 col-md-6 float-end mb-3">
                          <button
                            onClick={() => updateRemittanceValue(actionObject)}
                            className="login100-form-btn btn-primary fw-bold text-uppercase"
                          >
                            {loading ? (
                              <>
                                <i className="fa fa-spinner fa-spin" />
                              </>
                            ) : (
                              `${
                                dictionary ? dictionary["b_update"] : "UPDATE"
                              }`
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </ul>
              </Card>
              <Card>
                {/* 5 --> DONE** */}
                <ul className="list-group">
                  <li
                    className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                    onClick={() => setAuthSettings(!authSettings)}
                    aria-controls="example-collapse-text"
                    aria-expanded={open}
                    style={{ cursor: "pointer", borderBottom: "0px solid" }}
                  >
                    {action ? (
                      <i className="fa fa-minus" aria-hidden="true" />
                    ) : (
                      <i className="fa fa-plus" aria-hidden="true" />
                    )}{" "}
                    &nbsp;
                    {dictionary
                      ? dictionary["l_authentication_settings"]
                      : "Authentication Settings"}
                  </li>
                  <Collapse in={authSettings}>
                    <div id="example-collapse-text" className="px-3">
                      <h6 className="fw-bold">
                        {dictionary
                          ? dictionary["l_authentication_info"]
                          : `Set whether you'd like to support SMS authentification in transaction pay-out.
Cashiers will be able to authenticate transaction beneficiaries by sending SMS with an authentication code.`}
                      </h6>
                      <div className="form-row py-4">
                        {authObject.map((i, idx) => {
                          return (
                            <React.Fragment>
                              <div
                                className="col-md-6 col-lg-6"
                                key={i.id + idx}
                              >
                                <div className="py-3">
                                  <input
                                    type={"checkbox"}
                                    name={i.name}
                                    id={i.name}
                                    className="pe-3 check-box"
                                    onChange={(e) => onChangeAuthSettings(e)}
                                    checked={i.value}
                                  />
                                  <span className="ps-2 align-top">
                                    {i.title}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                      <div className="form-row pb-3">
                        <div className="col-lg-6 col-md-6" />
                        <div className="col-lg-6 col-md-6 float-end mb-3">
                          <button
                            onClick={() => updateRemittanceValue(authObject)}
                            className="login100-form-btn btn-primary fw-bold text-uppercase"
                          >
                            {loading ? (
                              <>
                                <i className="fa fa-spinner fa-spin" />
                              </>
                            ) : (
                              `${
                                dictionary ? dictionary["b_update"] : "UPDATE"
                              }`
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                </ul>
              </Card>
              <Card>
                {/* 6 --> DONE**  */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setPayOutAuth(!payOutAuth)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_PAYOUT_AUTHENTICATI_50541688"]
                    : "Pay-Out Authentication"}
                </li>
                <Collapse in={payOutAuth}>
                  <div id="example-collapse-text" className="px-3">
                    <h6 className="fw-bold">{`Set whether you'd like to support SMS authentification in transaction pay-out.
Cashiers will be able to authenticate transaction beneficiaries by sending SMS with an authentication code.`}</h6>
                    <div className="form-row py-4">
                      {payOutObject.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={i.id + idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) => onChangePayoutInput(e)}
                                  checked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => updateRemittanceValue(payOutObject)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 7 --> DONE** */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setSessionTimeout(!sessionTimeout)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["para_session_timeout_settings"]
                    : "Session Timeout Settings"}
                </li>
                <Collapse in={sessionTimeout}>
                  <div id="example-collapse-text" className="px-3">
                    <h6 className="fw-bold">
                      {dictionary
                        ? dictionary[
                            "para_control_session_timeout_settings_here"
                          ]
                        : `Control session timeout here.`}
                    </h6>
                    <div className="form-row py-4">
                      <div className="col-md-6 col-lg-6">
                        <div className="py-3">
                          <label>
                            {dictionary
                              ? dictionary["para_value_in_seconds"]
                              : `Enter value in seconds`}
                          </label>
                          <input
                            type={"text"}
                            name={"maxSessionInterval"}
                            id="maxSessionInterval"
                            defaultValue={remittanceValues?.maxSessionInterval}
                            className="pe-3 form-control"
                            onChange={(e) => setSessionControl(e.target.value)}
                            placeholder="300"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => {
                            const sessionObj = [
                              {
                                name: "maxSessionInterval",
                                value: parseFloat(sessionControl),
                              },
                            ];
                            updateRemittanceValue(sessionObj);
                          }}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 8 --> DONE** NOT UPDATING */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setTermsAndConds(!termsAndConds)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["l_terms_and_conds_details"]
                    : "Terms and Conditions Details on the Receipts"}
                </li>
                <Collapse in={termsAndConds}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      <div className="col-md-6 col-lg-6">
                        <div className="py-3">
                          <label>
                            {dictionary
                              ? dictionary["l_terms_and_conds"]
                              : `Terms and Conditions`}
                          </label>
                          <textarea
                            name={"receiptTermsNConditions"}
                            id={"receiptTermsNConditions"}
                            defaultValue={
                              remittanceValues?.receiptTermsNConditions
                            }
                            className="pe-3 pt-3 form-control"
                            onChange={(e) =>
                              setReceiptTermsAndConds(e.target.value)
                            }
                            style={{ height: "100px" }}
                          />
                          <span className="ps-2 align-top">{}</span>
                        </div>
                      </div>
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => {
                            // PROBLEM WITH THE KEY
                            const receiptObj = [
                              {
                                name: "receiptTermsAndConditions",
                                value: receiptTermsAndConds,
                              },
                            ];
                            updateRemittanceValue(receiptObj);
                          }}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 9 --> DONE** NOT UPDATING */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setPaymentTermsAndConds(!paymentTermsAndConds)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_PAYMENT_TERMS_AND_CO_688524614"]
                    : "Payment Terms and Conditions"}
                </li>
                <Collapse in={paymentTermsAndConds}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      <div className="col-md-6 col-lg-6">
                        <div className="py-3">
                          <label>
                            {dictionary
                              ? dictionary["WO_PAYMENT_TERMS_AND_CO_667933042"]
                              : `Payment Terms and Conditions`}
                          </label>
                          <textarea
                            name={"paymentTermsAndConditions"}
                            id={"paymentTermsAndConditions"}
                            defaultValue={
                              remittanceValues?.paymentTermsAndConditions
                            }
                            className="pe-3 pt-3 form-control"
                            onChange={(e) =>
                              setPaymentTermsAndConditions(e.target.value)
                            }
                            style={{ height: "100px" }}
                          />
                          <span className="ps-2 align-top">{}</span>
                        </div>
                      </div>
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => {
                            const payObj = [
                              {
                                name: "paymentTermsAndConditions",
                                value: paymentTermsAndConditions,
                              },
                            ];
                            updateRemittanceValue(payObj);
                          }}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 10  -->NA*/}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setKyc(!kyc)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_CUSTOMER_AUTOMATICAL_-1196144588"]
                    : "Customer approval (Know Your Customer)"}
                </li>
                <Collapse in={kyc}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {customerObject.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={i.id + idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) => onChangeCustomerInput(e)}
                                  checked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          disabled
                          // onClick={handleLogin}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {dictionary ? dictionary["b_update"] : "UPDATE"}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 11 --> DONE**  */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setAgeLimit(!ageLimit)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["para_sending_minimum_age_settings"]
                    : "User age limit Settings"}
                </li>
                <Collapse in={ageLimit}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {userAgeObject.map((i, idx) => {
                        const name = i.name;
                        const defaultValue =
                          remittanceValues !== undefined
                            ? remittanceValues[name]
                            : "";
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx + 1}>
                              <div className="py-3">
                                <input
                                  type={"text"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 form-control"
                                  onChange={(e) => onChangeUserAgeInput(e)}
                                  defaultValue={defaultValue}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => updateRemittanceValue(userAgeObject)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 12 --> N/A */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setRequiredFields(!requiredFields)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary[
                        "REQUIRED_FIELDS_FOR_ATTACH_DOCUMENT_-1975212357"
                      ]
                    : "REQUIRED FIELDS FOR ATTACH DOCUMENTS"}
                </li>
                <Collapse in={requiredFields}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {requiredFieldsObject.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) =>
                                    onChangeRequiredFieldsInput(e)
                                  }
                                  checked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          disabled
                          // onClick={handleLogin}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 14 */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setRefundSettings(!refundSettings)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["REFUND_SETTING_935328890"]
                    : "Refund Settings"}
                </li>
                <Collapse in={refundSettings}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {action_settings.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3"
                                  style={{ width: "18px", height: "18px" }}
                                  onChange={(e) => onChangeActionInput(e)}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          disabled
                          // onClick={handleLogin}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {dictionary ? dictionary["b_update"] : "UPDATE"}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 15 --> DONE** */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setLogoutUrl(!logoutUrl)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_LOGOUT_REDIRECT_UR_-830077325"]
                    : "Logout Redirect URL"}
                </li>
                <Collapse in={logoutUrl}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {logoutObject.map((i, idx) => {
                        const name = i.name;
                        const defaultValue =
                          remittanceValues !== undefined
                            ? remittanceValues[name]
                            : "";
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <label className="ps-2 align-top">
                                {i.title}
                              </label>
                              <div className="py-3">
                                <input
                                  type={"text"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 form-control"
                                  onChange={(e) => onChangeLogoutInput(e)}
                                  defaultValue={defaultValue}
                                />
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => updateRemittanceValue(logoutObject)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 16 --> DONE NOT UPDATING */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setMobileApp(!mobileApp)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_MOBILE_APP_VERSION_1680748479"]
                    : "Mobile app versions"}
                </li>
                <Collapse in={mobileApp}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {mobileAppObject.map((i, idx) => {
                        const name = i.name;
                        const defaultValue =
                          remittanceValues !== undefined
                            ? remittanceValues[name]
                            : "";
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <label className="ps-2 align-top">
                                {i.title}
                              </label>
                              <div className="py-3">
                                <input
                                  type={"text"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 form-control"
                                  onChange={(e) => onChangeMobileInput(e)}
                                  defaultValue={defaultValue}
                                />
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => updateRemittanceValue(mobileAppObject)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 17 --> DONE**  */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setEnablePickup(!enablePickup)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_ENABLE_PICKUP_LOCATI_-656274473"]
                    : "Enable pickup location."}
                </li>
                <Collapse in={enablePickup}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {enableObject.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) => onChangeEnableInput(e)}
                                  value={i.value}
                                  checked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => updateRemittanceValue(enableObject)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 18 --> DONE** */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setEnableTeller(!enableTeller)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_ENABLE_TELLERS_TILL_727942573"]
                    : "Enable Tellers Till Account Pull"}
                </li>
                <Collapse in={enableTeller}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {tillAccObject.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) => onChangeTillAccInput(e)}
                                  value={i.value}
                                  checked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => updateRemittanceValue(tillAccObject)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 19 --> DONE NOT UPDATING */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setEnableOverdraft(!enableOverdraft)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_ENABLE_OVERDRAF_950277517"]
                    : "Enable OverDraft"}
                </li>
                <Collapse in={enableOverdraft}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {overdraftObject.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) => onChangeOverdraftInput(e)}
                                  value={i.value}
                                  checked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() => updateRemittanceValue(overdraftObject)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
              <Card>
                {/* 20 --> DONE NOT UPDATEING NA */}
                <li
                  className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                  onClick={() => setServiceAvailable(!serviceAvailable)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {action ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["WO_SERVICES_AVAILABLE_T_-1007165566"]
                    : "Services available to none members"}
                </li>
                <Collapse in={serviceAvailable}>
                  <div id="example-collapse-text" className="px-3">
                    <div className="form-row py-4">
                      {noneMembersObject.map((i, idx) => {
                        return (
                          <React.Fragment>
                            <div className="col-md-6 col-lg-6" key={idx}>
                              <div className="py-3">
                                <input
                                  type={"checkbox"}
                                  name={i.name}
                                  id={i.name}
                                  className="pe-3 check-box"
                                  onChange={(e) => onChangeMembersInput(e)}
                                  value={i.value}
                                  checked={i.value}
                                />
                                <span className="ps-2 align-top">
                                  {i.title}
                                </span>
                              </div>
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>
                    <div className="form-row pb-3">
                      <div className="col-lg-6 col-md-6" />
                      <div className="col-lg-6 col-md-6 float-end mb-3">
                        <button
                          onClick={() =>
                            updateRemittanceValue(noneMembersObject)
                          }
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </Card>
            </>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;

/* <div className="card overflow-hidden">
                <div className="card-body">
                  <ul className="list-group mb-2">
                    <li
                      className="list-group-item collapse-text text-uppercase py-3 fw-bold text-uppercase"
                      onClick={() => setApiSetup(!apiSetup)}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                      style={{ cursor: "pointer" }}
                    >
                      {action ? (
                        <i className="fa fa-minus" aria-hidden="true" />
                      ) : (
                        <i className="fa fa-plus" aria-hidden="true" />
                      )}{" "}
                      &nbsp;
                      {dictionary
                        ? dictionary["WO_API_INTEGRATION_FOR_1322884688"]
                        : "API Setup [Currency Feed, Facebook/Google Login, Address Lookup]"}
                    </li>
                    <Collapse in={apiSetup}>
                      <div id="example-collapse-text" className="px-3">
                        <div className="form-row py-4">
                          {action_settings.map((i, idx) => {
                            return (
                              <React.Fragment>
                                <div
                                  className="col-md-6 col-lg-6"
                                  key={i.id + idx}
                                >
                                  <div className="py-3">
                                    <input
                                      type={"checkbox"}
                                      name={i.name}
                                      id={i.name}
                                      className="pe-3"
                                      style={{ width: "18px", height: "18px" }}
                                      onChange={(e) => onChangeActionInput(e)}
                                    />
                                    <span className="ps-2 align-top">
                                      {i.title}
                                    </span>
                                  </div>
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                        <div className="form-row pb-3">
                          <div className="col-lg-6 col-md-6" />
                          <div className="col-lg-6 col-md-6 float-end mb-3">
                            <button
                              disabled
                              // onClick={handleLogin}
                              className="login100-form-btn btn-primary fw-bold text-uppercase"
                            >
                              {dictionary ? dictionary["b_update"] : "UPDATE"}
                            </button>
                          </div>
                        </div>
                      </div>
                    </Collapse>
                  </ul>
                </div>
              </div> */
